module.exports = __webpack_public_path__ + "assets/adaf3a82.png";


//////////////////
// WEBPACK FOOTER
// ./src/header/datart.png
// module id = 88
// module chunks = 0